import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { IAccountInfo } from 'src/app/interfaces/iaccount-info';
import { ICustomerInfo } from 'src/app/interfaces/icustomer-info';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-customer-account-list-modal',
  templateUrl: './customer-account-list-modal.component.html',
  styleUrls: ['./customer-account-list-modal.component.scss'],
  standalone: false,
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'general',
    },
  ],
})
export class CustomerAccountListModalComponent {
  @Input() accountsByCustomer: ICustomerInfo[] = [];
  @Input() selectedAccountInfo: IAccountInfo | null = null;
  @Output() optionSelected = new EventEmitter<IAccountInfo>();
  @Output() clickOutside = new EventEmitter<string>();

  constructor(private translationService: TranslationService) {}

  ngOnInit() {
    this.translationService.loadScopedTranslation('general');
  }

  selectOption(option: IAccountInfo) {
    console.log(option);
    this.optionSelected.emit(option);
  }

  onClickOutside() {
    this.clickOutside.emit('Outside click');
  }
}
